import _ from "lodash";
import React from "react";

export default function SwitcherInformer({ state }) {
  if (!_.isUndefined(state)) {
    if (state) {
      return <div className="switch-informer informer-yes">Yes</div>;
    }

    return <div className="switch-informer">No</div>;
  }

  return <div className="switch-informer informer-undefined">Unknown</div>;
}
